// Presentation only. The room retains full history for records, settlement and replies.
export function selectDesktopChatMessages(messages) {
  return messages.filter((message) => !['attack_order', 'raid_result'].includes(message.type));
}

// The room supplies chronological messages; display recent results newest first.
export function selectRecentRaidResults(messages) {
  return messages.filter((message) => message.type === 'raid_result').slice(-5).reverse();
}
